module.exports = "/assets/111fa33304bb1c6d0919d7a8a51524b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/UP.png
// module id = 1899
// module chunks = 0